<template>
    <div>
        <template>
            <h5 class="my-4">{{ $t('managerForm.settingAdvanced.sendingInformation') }}</h5>
            <div class="ml-3">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingAdvanced.settingSending') }}</label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap" style="gap: 12px">
                            <div v-for="(item, idx) in OPTION_SEND_EMAIL" :key="idx">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="initForm.option_send_email"
                                    :name="`answerm-option-send-email-${idx}`"
                                    :id="`answerm-option-send-email-${idx}`"
                                    :value="item.id"
                                    :label="item.label"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="!optionSend3">
            <h5 class="pt-3 mb-4" style="border-top: 1px solid #ccc">
                {{ !optionSend2 ? $t('managerForm.settingAdvanced.basicEmailSettings') : $t('managerForm.settingAdvanced.settingConditions') }}
            </h5>
            <div class="ml-3">
                <!-- 差出人アドレス -->
                <div v-if="optionSend1" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                        >{{ $t('managerForm.settingAdvanced.fromAddress') }}
                        <span v-if="onHandleCheckFieldRequired(configData.configFieldFromAddress.typesValidate)" class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`answerm-fromAddress`"
                            :value.sync="initForm.from_address"
                            :options="listEmailFromAddress"
                            :config="configData.configFieldFromAddress"
                        />
                    </div>
                </div>
                <!-- 宛先アドレス -->
                <div v-if="optionSend1" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                        >{{ $t('managerForm.settingAdvanced.toAddress') }}
                        <span v-if="onHandleCheckFieldRequired(configData.configFieldReplyAddress.typesValidate)" class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`answerm-replyAddress`"
                            :value.sync="initForm.to_address"
                            :options="OPTION_REPLY_ADDRESS"
                            :config.sync="configData.configFieldReplyAddress"
                            @select="handleSelectReplyAddress"
                        />
                    </div>
                </div>
                <!-- BCCアドレス  -->
                <div v-if="optionSend1" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                        >{{ $t('managerForm.settingAdvanced.bcc') }}
                        <span v-if="onHandleCheckFieldRequired(configData.configFieldBccAddress.typesValidate)" class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <InputText
                            :id="`answerm-bccAddress`"
                            :model.sync="initForm.bcc_address"
                            :config.sync="configData.configFieldBccAddress"
                            @blur="handleValidateField(configData.configFieldBccAddress, 'more-mail')"
                        />
                        <span class="inputSupportInfo">{{ $t('managerForm.settingAdvanced.noteBlockConditionMail') }}</span>
                    </div>
                </div>
                <!-- 件名 -->
                <div v-if="optionSend1" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                        >{{ $t('managerForm.settingAdvanced.subject') }}
                        <span v-if="onHandleCheckFieldRequired(configData.configFieldSubject.typesValidate)" class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <InputText
                            :id="`answerm-Subject`"
                            :model.sync="initForm.subject"
                            :config.sync="configData.configFieldSubject"
                            @blur="handleValidateField(configData.configFieldSubject)"
                        />
                    </div>
                </div>
                <!-- 本文 -->
                <div v-if="optionSend1" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                        >{{ $t('managerForm.settingAdvanced.mainText') }}
                        <span v-if="onHandleCheckFieldRequired(configData.configFieldMainText.typesValidate)" class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <div class="position-relative">
                            <div class="pl-0 col-sm-4">
                                <Multiselect
                                    :id="`blockChoiceSendingMail`"
                                    :value="blockChoiceSendingMail"
                                    :options="listOriginBlock"
                                    :config="configData.configFieldSelectChoiceSendingMail"
                                    @select="onHandleSetBlockChoiceSendingMail"
                                />
                            </div>
                            <div class="w-100">
                                <Editor
                                    ref="TextareaAnswer"
                                    :id="`mainText-answer-${initForm.option_send_email}`"
                                    :key="`mainText-answer-${initForm.option_send_email}`"
                                    :model.sync="initForm.main_text"
                                    :configInit="editorConfigWithoutVideo"
                                    :configError.sync="configData.configFieldMainText"
                                    @blur="handleValidateField(configData.configFieldMainText)"
                                />
                                <div v-if="configData.configFieldMainText.error" class="d-block invalid-feedback mt-1">
                                    <span>
                                        {{ configData.configFieldMainText.errorCustomMess }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="optionSend2">
                <div class="ml-3">
                    <!-- メール送信条件 -->
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                            >{{ $t('managerForm.settingAdvanced.conditionSendEmail') }}
                            <span
                                v-if="onHandleCheckFieldRequired(configData.configFieldSelectMailSendingConditions.typesValidate)"
                                class="text-danger"
                                >*</span
                            ></label
                        >
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-sm-8">
                                    <Multiselect
                                        :id="`answerm-conditionSendEmail`"
                                        :value.sync="initForm.block_id"
                                        :options="blockList"
                                        :config.sync="configData.configFieldSelectMailSendingConditions"
                                        @select="handleSelectBlock"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <BlockSending
                v-if="initForm.block_id && optionSend2"
                style="border-top: 1px solid #ccc"
                ref="blockSendingAnswer"
                :opTabpanel.sync="initForm.email_settings_for_each_option"
                :configData="configConditionSendBlock"
                :mailList="listMail"
                :listOriginBlock="listOriginBlock"
                :listEmailFromAddress="listEmailFromAddress"
            />
        </template>
    </div>
</template>

<script>
import { OPTION_SEND_EMAIL, OPTION_NOT_SELECTED, initSettingEmailOptionAnswer, selectDefaultSendmail } from '../../constants';
import { InputRadio, InputText } from '@/components/Input';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { validateField } from '@/utils/validate';
import { VALUE_ETC } from '../../../../../iframe-page/handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { onHandleMoreMail, onHandleFilterOptionSendEmail, onHandleEditorConfigWithoutVideo } from '../../handlers';

import Multiselect from '@/components/Multiselect/main.vue';
import Editor from '@/components/Editor/main.vue';
import BlockSending from './block-sending.vue';

export default {
    name: 'AlertUserAnswer',
    components: {
        InputRadio,
        InputText,
        Multiselect,
        Editor,
        BlockSending
    },
    props: {
        formData: {
            type: Object,
            required: true,
            default: () => {}
        },
        configData: {
            type: Object,
            required: true,
            default: () => {}
        },
        listBlock: {
            type: Array,
            required: true,
            default: () => []
        },
        listMail: {
            type: Array,
            required: true,
            default: () => []
        },
        listEmailFromAddress: {
            type: Array,
            required: true,
            default: () => []
        },
        listOriginBlock: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        optionSend1() {
            return this.initForm.option_send_email === OPTION_SEND_EMAIL()[0].id;
        },
        optionSend2() {
            return this.initForm.option_send_email === OPTION_SEND_EMAIL()[1].id;
        },
        optionSend3() {
            return this.initForm.option_send_email === OPTION_SEND_EMAIL()[2].id;
        }
    },
    data() {
        return {
            OPTION_SEND_EMAIL: OPTION_SEND_EMAIL(),
            OPTION_REPLY_ADDRESS: [],
            VALUE_ETC,
            OPTION_NOT_SELECTED,
            initForm: this.formData,
            configForm: this.configData,
            blockList: this.listBlock,
            configConditionSendBlock: [],
            blockChoiceSendingMail: selectDefaultSendmail(),
            editorConfigWithoutVideo: onHandleEditorConfigWithoutVideo()
        };
    },
    methods: {
        onHandleCheckFieldRequired,

        handleValidateField(configField, action) {
            validateField(configField);
            switch (action) {
                case 'more-mail':
                    onHandleMoreMail(configField, 'one');
                    break;
            }
        },

        handleSelectReplyAddress() {
            // this.initForm.email_reply_address = '';
            // this.configForm.configFieldReplyAddress.error = false;
        },

        handleSelectBlock(block) {
            let blockType = block.block_type;
            let optionBlock = block.options;
            let optionsValue = [];
            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (block.extension.setting_others.other_use) {
                        optionsValue = [
                            ...optionBlock,
                            {
                                id: VALUE_ETC,
                                is_custom_value: true,
                                value: block.extension.setting_others.label_other
                            },
                            ...OPTION_NOT_SELECTED
                        ];
                    } else {
                        optionsValue = [...optionBlock, ...OPTION_NOT_SELECTED];
                    }
                    break;
                default:
                    optionsValue = [...optionBlock, ...OPTION_NOT_SELECTED];
                    break;
            }

            const optionList = optionsValue.map((itOp) => {
                return {
                    ...initSettingEmailOptionAnswer(),
                    value: itOp.value,
                    option_id: itOp.id,
                    is_custom_value: itOp?.is_custom_value ?? false,
                    is_not_selected: itOp?.is_not_selected ?? false,
                    choice_reply_address: null
                };
            });
            this.initForm.email_settings_for_each_option = optionList;
            this.configConditionSendBlock = optionList.map(() => initSettingEmailOptionAnswer().configEachField());
            if (this.$refs?.blockSendingAnswer) {
                this.$refs.blockSendingAnswer.onSetActiveBlockTab();
            }
        },

        onHandleSetBlockChoiceSendingMail(evt) {
            const editor = this.$refs.TextareaAnswer.editorInstance;
            if (!editor) return;
            editor.insertContent(`<<${evt.label}>>`);
            this.blockChoiceSendingMail = selectDefaultSendmail();
        }
    },
    watch: {
        formData: {
            handler(val) {
                this.initForm = val;
                this.configConditionSendBlock = val?.email_settings_for_each_option?.map((item) =>
                    initSettingEmailOptionAnswer(item).configEachField(item)
                );
            },
            immediate: true,
            deep: true
        },

        configData: {
            handler(val) {
                this.configForm = val;
            },
            immediate: true,
            deep: true
        },

        listBlock: {
            handler(val) {
                this.blockList = val;
                this.OPTION_SEND_EMAIL = onHandleFilterOptionSendEmail(val, OPTION_SEND_EMAIL());
            },
            immediate: true,
            deep: true
        },

        listMail: {
            handler(val) {
                this.OPTION_REPLY_ADDRESS = val;
                this.initForm.choice_reply_address = this.OPTION_REPLY_ADDRESS[0];
            },
            immediate: true,
            deep: true
        },

        initForm: {
            handler(val) {
                this.$emit('update:formData', val);
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
